import { MijnRoute } from '../mijn-navigatie.model';

export const ASN_MIGRATION_ONBOARDING: MijnRoute = {
    path: 'nieuwe-login-aanmelden',
    navigationEvent: 'toAsnMigrationOnboarding',
    regex: /^\/nieuwe-login-aanmelden$/,
    webcomponent: 'mijn-klant-onboarding-webcomponent'
};
